/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Legal_Load_FailedInputs */

const en_admin_legal_load_failed = /** @type {(inputs: Admin_Legal_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load settings`)
};

const de_admin_legal_load_failed = /** @type {(inputs: Admin_Legal_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen konnten nicht geladen werden`)
};

/**
* | output |
* | --- |
* | "Failed to load settings" |
*
* @param {Admin_Legal_Load_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_legal_load_failed = /** @type {((inputs?: Admin_Legal_Load_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Legal_Load_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_legal_load_failed(inputs)
	return en_admin_legal_load_failed(inputs)
});